export default {
    "title": "Application Complete",
    "hideElements": true,
    "description": `
        <p>Thank you for submitting your application. We will review your application and get back to you shortly.</p>
    `
};
